import SelectInput from "../../../components/input/SelectInput";
import Spinner from "../../../components/spinner/Spinner";
import ProjectDataCard from "../components/ProjectDataCard";
import Pagination from "../../../components/pagination/Pagination";

const LargeScreen = ({
  loading,
  selectedTab,
  count,
  selectedSortItem,
  projects,
  currentPage,
  sortItems,
  favouriteProjects,
  handleSelectedSortItem,
  handlePageChanged,
  handleArchive,
  handleFavourite,
  map
}) => {
  const checkFav = (id) => {
    const isFavourite = favouriteProjects?.find((project) => project?.id === id);
    if (isFavourite) {
      return true;
    }
    return false;
  };
  return (
    <>
      <div className="col-6 ps-0">{map}</div>

      <div className="col-6 row-cols-2 justify-content-between my-2 project-list-div">
        <div className="col-12 mt-4 mt-lg-5 row row-cols-2 mb-5 large-screen-details">
          <div className="d-flex px-0 col-6 align-items-center">
            <h4 className="text-start me-3 font-oswald lead-text">
              Projects Board
            </h4>
            <div className="text-start body-text">Showing {count} Results.</div>
          </div>
          <div className="d-flex px-0 col-5 align-items-center ms-auto">
            <p className="mb-0 ms-auto body-text-bold">Sort by:</p>
            <div className="project-board-drop-filter ms-auto">
              <SelectInput selectedItem={selectedSortItem}>
                {sortItems.map((item) => (
                  <div
                    key={item.id}
                    onClick={() => handleSelectedSortItem(item.id)}
                    className="cursor-pointer select-input-item py-2 ps-4"
                  >
                    {item.value}
                  </div>
                ))}
              </SelectInput>
            </div>
          </div>
        </div>
        {/* <div className="col-12 mt-4 mt-lg-0 row row-cols-2 pb-4 col-12 overflow-scroll project-board-card-container"> */}
        <div className="col-12 mt-4 mt-lg-0 project-bb overflow-scroll">
          {/* <div className="mt-4 mt-lg-0 row row-cols-2 col-12 pb-4 overflow-scroll"> */}
          {loading ? (
            <div className="m-auto large-screen-pag">
              <Spinner />
            </div>
          ) : (
            projects?.map((project) => (
              <ProjectDataCard
                key={project.id}
                handleArchive={handleArchive}
                handleFavourite={handleFavourite}
                isFavourite={checkFav(project.id)}
                {...project}
              />
            ))
          )}
          <div className="col-12 large-screen-pag">
            {loading ? (
              ""
            ) : (
              <Pagination
                totalRecords={count}
                pageLimit={10}
                pageNeighbours={1}
                onPageChanged={handlePageChanged}
                pageNumber={currentPage}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default LargeScreen;
